export const Extruder_Selector_Elements = {
    Extruder_Selection_Table: "extruder-selection-table",
    Extruder_Selection_Row: "extruder-selection-row",
    Extruder_Selection_Button: "extruder-selection-button"
};
